import
{
    AGENTSURVEYSCREEN_LOAD,
    AGENTSURVEYSCREEN_UNLOAD,
    AGENTSURVEYSCREEN_SET,
} from '../../../../actionDefinitions';
import { createReducer } from '../../../../reducerUtils';

const initialState =
{
    startDate: undefined,
    endDate: undefined,
};

const handlers = {
    [AGENTSURVEYSCREEN_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [AGENTSURVEYSCREEN_UNLOAD]: () => initialState,
    [AGENTSURVEYSCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
